module.exports = __webpack_public_path__ + "static/media/logo_makeover_grey.85f00678.png";